module.exports = __webpack_public_path__ + "img/mentor.8bc137ca.svg";